// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Classroom,
    ClassroomFromJSON,
    ClassroomToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2001
     */
    next?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2001
     */
    previous?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2001
     */
    count: number;
    /**
     * 
     * @type {Array<Classroom>}
     * @memberof InlineResponse2001
     */
    results: Array<Classroom>;
}

export function InlineResponse2001FromJSON(json: any): InlineResponse2001 {
    return {
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'count': json['count'],
        'results': (json['results'] as Array<any>).map(ClassroomFromJSON),
    };
}

export function InlineResponse2001ToJSON(value?: InlineResponse2001): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'next': value.next,
        'previous': value.previous,
        'count': value.count,
        'results': (value.results as Array<any>).map(ClassroomToJSON),
    };
}


